
export default {
  name: 'FooterShopLinks',
}
